import { render, staticRenderFns } from "./audit-logs-detail.vue?vue&type=template&id=7ac5bca6&scoped=true"
import script from "./audit-logs-detail.vue?vue&type=script&lang=js"
export * from "./audit-logs-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac5bca6",
  null
  
)

export default component.exports